import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import { useIsResponsive } from 'hooks/use-media-query';
import { CpLoadingProps, TitleAndDesc } from '../common';
import {
  CpCardsGridLoading,
  CpSummaryInformationLoadingSkeleton,
} from '../cp-summary-info-loading/cp-summary-info-loading';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cp-spacing-08);
`;

const TitleAndDescWrapper = styled.div`
  width: 25%;
`;

const CardsWrapper = styled.div`
  width: 75%;
`;

export const CpMetricsLoading: React.FC<CpLoadingProps> = ({
  input,
  variantType,
  styles,
}) => {
  const isResponsive = useIsResponsive();

  if (
    variantType === CpWidgetVariantType.MetricsRightSidedGrid &&
    !isResponsive
  ) {
    return (
      <CpSectionWrapper
        background={styles?.background as string}
        paddingY={styles?.paddingY as number | undefined}
        className="!cp-max-w-none"
      >
        <Wrapper>
          <TitleAndDescWrapper>
            <TitleAndDesc
              desc={input?.desc as string}
              title={input?.title as string}
            />
          </TitleAndDescWrapper>
          <CardsWrapper>
            <CpCardsGridLoading />
          </CardsWrapper>
        </Wrapper>
      </CpSectionWrapper>
    );
  }

  return (
    <CpSummaryInformationLoadingSkeleton
      input={input}
      variantType={variantType}
      styles={styles}
    />
  );
};
